import CityPageTemplate from "../city-template/CityPageTemplate";
import { winstonSalemConfig } from "./data";

export default function WinstonSalemPage() {
  return <CityPageTemplate config={winstonSalemConfig} />;
}